var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnAsNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.504l-2.457-4.1-1.386 4.1H16zm-4.032.574L8.84 14.362l7.097-9.284h-3.969zm-4.787 9.284L4.052 5.078H.084l7.098 9.284H7.18zM3.864 4.504L2.478.404 0 4.504h3.864zm7.496.574H4.66L8 15l3.36-9.922zm-6.657-.574h6.615L8.001.191 4.704 4.504zm6.993-.446L13.06 0H8.588l3.108 4.058zM7.412 0H2.94l1.386 4.058L7.412 0z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgIcnAsNew;